import AccountSettingsBase from './account-settings-base'

export default class CourierAccountSettings extends AccountSettingsBase {
  constructor (store) {
    super(store, 'courierAccount')
  }
}
